export default __webpack_public_path__ + "static/media/facebook.4e2d6aee.svg";